export const handleOnPageChange = (currentParams, fetchDataFunction = null, page, per_page) => {
  if (fetchDataFunction) {
    fetchDataFunction({
      ...currentParams,
      page,
      per_page,
    });
  } else {
    console.error('Fetch data function was not passed to handleOnPageChange');
  }
};
